export enum COMMON_PERMISSIONS_OPERATOR {
	AND = 'AND',
	OR = 'OR',
}
